export default function shake() {
    this.classList.add('shake');
    this.style.animation = 'none';
    this.offsetHeight; /* trigger reflow */
    this.style.animation = null;
}